import React from 'react';

const PageHeading = ({ children }) => (
  <h1 className="text-black text-4xl font-bold mb-3">{children}</h1>
);

export default PageHeading;
